import styled from 'styled-components';
import InputMask from 'react-input-mask';
import { cardShadow } from '../../themes/shadows';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  height: 95%;
  align-items: center;
  justify-content: center;
  margin: auto;
`;

export const StepperConteiner = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  width: calc(100% - 220px);
  margin: 0 20px 0 200px;

  @media (max-width: 1050px) {
    margin: 0 0px 0 20px;
    width: calc(100% - 20px);
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  width: 100%;
  height: 80%;
  align-items: flex-start;
  justify-content: start;
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  #buttonContainer {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin: 0 0 45px 0;
  }
`;

export const Label = styled.label`
  font-size: ${(props) => props.size || '14px'};
  color: ${(props) => props.color || props.theme.colors.label};
  ${(props) => props.bold && 'font-weight: bold'};
  ${(props) => props.pointer && 'cursor: pointer'};
`;

export const Icon = styled.img`
  width: ${(props) => props.size || props.width};
  height: ${(props) => props.size || props.height};
  cursor: ${(props) => props.pointer && 'pointer'};
  ${(props) => props.margin && `margin: ${props.margin}`}
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: start;
  justify-content: center;
  background-image: ${(props) => props.url && `url(${props.url})`};
  background-repeat: no-repeat;

  #content {
    margin: 16px 0 0 260px;
  }

  @media (max-width: 1050px) {
    margin: 0 0px 0 20px;
    width: calc(100% - 20px);
    #content {
      margin: 0 0px 0 20px;
      width: calc(100% - 20px);
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 190px 0 40px 0;
  align-items: flex-start;
  justify-content: center;
  ${(props) => props.input && 'margin: 10px 0'};

  #phone {
    display: flex;
    width: min(500px, 90vw);
    background: ${(props) => props.theme.colors.lightgrey};
    color: ${(props) => props.theme.colors.label};
    font-size: 12px;
    border-radius: 10px;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
    margin: 15px 15px 15px 0;
  }
`;

export const Title = styled.h1`
  color: ${(props) => props.theme.colors.darkblue};
  font-size: var(--fs-heading);
  margin: ${(props) => props.margin || '0 0 40px 0'};
`;

export const SubTitle = styled.label`
  font-size: 20px;
  color: ${(props) => props.theme.colors.label};
  margin: 0 0 50px 0;
`;

export const Resume = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  #item {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
  }

  label {
    font-size: 20px;
    color: ${(props) => props.theme.colors.darkblue};
    margin: 10px;
  }
`;

export const PasswordWarning = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 210px;
  height: 175px;
  box-shadow: ${cardShadow};
  border-radius: 14px;
  margin: 100px 20px 0 50%;
  position: absolute;

  @media (max-width: 1180px) {
    flex-direction: row;
    position: relative;
    margin: 0;
    width: min(500px, 92vw);
    height: auto;
    min-height: 70px;
    padding: 8px 12px;
    box-sizing: border-box;
  }
`;

export const ErrorMessage = styled.div`
  font-size: 20px;
  color: ${(props) => props.theme.colors.red};
`;

export const MaskedInput = styled(InputMask)`
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: ${(props) =>
    props.value ? props.theme.colors.darkblue : props.theme.colors.label};
  border-radius: 10px;
  :disabled {
    cursor: not-allowed;
    opacity: 0.8;
  }
  background: ${(props) => props.theme.colors.lightgrey};
`;
